export type GeneralErrorTranslation = {
  default: string;
  forbidden: ErrorTranslation;
  goBack: string;
  notAuthorized: ErrorTranslation;
  notFound: ErrorTranslation;
  wentWrong: string;
};

type ErrorTranslation = {
  message: string;
  subMessage?: string;
};

export const generalErrorTranslation: GeneralErrorTranslation = {
  default: 'The operation has failed, try again or contact the application administrator.',
  forbidden: {
    message: 'You are not authorized to access this site or your session has expired.',
    subMessage:
      'If you think that you should be authorized, ask your manager or supervisor to grant you access.',
  },
  goBack: 'Go back',
  notAuthorized: {
    message: 'Access Denied',
    subMessage:
      'You do not have the required permissions to login to the KnowMe system. If you believe this to be an error or if you should possess these permissions, please contact Orange Cyberdefense for further assistance.',
  },
  notFound: {
    message: 'The site does not exist!',
  },
  wentWrong: 'Ooops! Something went wrong',
};
